import { Controller } from '@hotwired/stimulus';
import { templateContent } from '@/js/util';

export default class extends Controller {
  static targets = ['interactiveZone', 'dragZone', 'dropZone', 'picker'];

  #dragDepth;
  #dragAllowed;

  connect() {
    this.#dragDepth = 0;
    this.#dragAllowed = false;

    this.reset();
  }

  tryEnable(event) {
    if (this.isAllowed(event)) {
      this.#enableDrag();
    }
  }

  onDragEnter(event) {
    this.#dragDepth++;
    if (this.isAllowed(event) && this.#dragDepth === 1) {
      this.#dragAllowed = true;
      this.showDropZone();
    }
  }

  onDragOver(event) {
    if (this.#dragAllowed) {
      event.preventDefault();
    }
  }

  onDragLeave() {
    this.#dragDepth = Math.max(0, this.#dragDepth - 1);
    if (this.#dragDepth === 0) {
      this.reset();
    }
  }

  decline({ type }) {
    if (type !== 'visibilitychange' || document.hidden) {
      this.reset();
    }
  }

  reset() {
    this.#dragDepth = 0;
    this.#dragAllowed = false;
    this.#hideDropZone();
    this.#disableDrag();
  }

  isAllowed({ dataTransfer }) {
    if (dataTransfer) {
      return dataTransfer.types.some((type) => type === 'Files');
    }

    return false;
  }

  openPicker() {
    document.body.append(templateContent(this.pickerTarget));
  }

  showDropZone() {
    this.#enableDrag();

    this.interactiveZoneTarget.innerHTML = '';
    const dropZone = this.dropZoneTarget.content.cloneNode(true);
    this.interactiveZoneTarget.appendChild(dropZone);
  }

  #hideDropZone() {
    this.interactiveZoneTarget.innerHTML = '';
    const dragZone = this.dragZoneTarget.content.cloneNode(true);
    this.interactiveZoneTarget.appendChild(dragZone);
  }

  #enableDrag() {
    this.interactiveZoneTarget.classList.remove('pointer-events-none');
    this.interactiveZoneTarget.classList.add('pointer-events-auto');
  }

  #disableDrag() {
    this.interactiveZoneTarget.classList.add('pointer-events-none');
    this.interactiveZoneTarget.classList.remove('pointer-events-auto');
  }
}
